import { useAppSelector } from '../../../redux/store'
import { selectUserGoogleInfo, selectUserTeamMemberInfo } from '../../../redux/auth/selector'
import { AppBar, Divider, Grid, Toolbar, Typography } from '@mui/material'
import { fontSizes } from '../../Common/Typography/TypographyStyles'
import { Box } from '@mui/system'
import { backgroundColors, gradientColors, textColors } from '../../Common/Color/Color'
import DisabledTextField from '../../Common/DisabledTextField'

const MyProfile = () => {
  const teamMemberDetails = useAppSelector(selectUserTeamMemberInfo)
  const userGoogleInfo = useAppSelector(selectUserGoogleInfo)
  return (
    <>
      <AppBar
        position='static'
        sx={{
          boxShadow: 'none',
          background: gradientColors.greenGradient,
          color: textColors.white,
          borderRadius: 2,
        }}
      >
        <Toolbar>
          <Typography fontSize={fontSizes.size20} fontWeight={600}>
            MY PROFILE
          </Typography>
        </Toolbar>
      </AppBar>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ p: 5 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 4 }} spacing={2} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 200,
                height: 200,
                borderRadius: '50%',
                overflow: 'hidden',
                backgroundColor: backgroundColors.greyAthens,
                boxShadow: 1,
              }}
            >
              <img
                src={userGoogleInfo.picture}
                alt='Profile'
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }} spacing={2}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              <DisabledTextField
                id='employee-name'
                label='Name'
                value={
                  teamMemberDetails.firstName +
                  ' ' +
                  teamMemberDetails.middleName +
                  ' ' +
                  teamMemberDetails.lastName
                }
                fullWidth
              />
              <DisabledTextField
                id='employee-email'
                label='Email'
                value={teamMemberDetails.email}
                fullWidth
              />
              <DisabledTextField
                id='supervisor-name'
                label='Supervisor'
                value={teamMemberDetails.supervisor.name}
                fullWidth
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }} spacing={2}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
              <DisabledTextField
                id='workday-id'
                label='Workday ID'
                value={teamMemberDetails.workdayId}
                color='secondary'
                fullWidth
              />
              <DisabledTextField
                id='functional-area'
                label='Functional Area'
                value={teamMemberDetails.functionalArea}
                fullWidth
              />
              <DisabledTextField
                id='job-profile'
                label='Job Profile'
                value={teamMemberDetails.jobProfile}
                fullWidth
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default MyProfile
